import { render } from "./review.vue?vue&type=template&id=2ba5a154&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"

import "./review.vue?vue&type=style&index=0&id=2ba5a154&lang=css"
import "./review.vue?vue&type=style&index=1&id=2ba5a154&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba5a154"]])

export default __exports__